import { Input } from 'common/InputForm';
import { CustomModal } from 'components/modals/ModalBox';
import useButtonLoader from 'hooks/useButtonLoader';
import React, { useEffect, useState } from 'react'
import DatePicker from 'react-datepicker';
import { format, parse, setMinutes, setHours } from "date-fns";
import { addSlotAPi, updateSlotApi } from 'services/masterApi';
const UpdateSlot = ({ show, close, data, slotType, listing = () => { } }) => {

    const [buttonLoader, setButtonLoader] = useButtonLoader("submit");
    // separate states for start & end time
    const [slot, setSlot] = useState({
        from: new Date(),
        to: new Date(),
    });
    // console.log({ data, slot })
    // handle change
    const handleChange = (key, value) => {
        setSlot((prev) => ({ ...prev, [key]: value }));
    };
    // -----find-current-time-------------
    const getMinTime = () => {
        const now = new Date();
        const minutes = now.getMinutes();
        const roundedMinutes = Math.ceil(minutes / 15) * 15; // round up to next 15
        return setMinutes(now, roundedMinutes);
    };
    const handleClose = () => {
        close()
        setSlot({
            from: new Date(),
            to: new Date(),
        });
    }
    useEffect(() => {
        if (data?.type === "Update") {
            setSlot({
                from: data?.from
                    ? parse(data.from, "hh:mm a", new Date())
                    : new Date(),
                to: data?.to
                    ? parse(data.to, "hh:mm a", new Date())
                    : new Date(),
            });
        }
    }, [data?.type]);

    // const payload = {
    //     from: slot.from ? format(slot.from, "hh:mm a") : "",
    //     to: slot.to ? format(slot.to, "hh:mm a") : "",
    // };

    const updateDeliverySlot = async () => {
        setButtonLoader(true);
        try {
            let payLoad = {
                type: "DELIVERYSLOTS",
                slotType: slotType,
                from: slot.from ? format(slot.from, "hh:mm a") : "",
                to: slot.to ? format(slot.to, "hh:mm a") : "",

            }
            if (data?.type == 'Update') {
                payLoad.id = data?._id;
            }

            // console.log('payLoad', payLoad)
            const res = data?.type == 'Update' ? await updateSlotApi(payLoad) : await addSlotAPi(payLoad);
            // console.log("res",res?.data);
            if (res?.data?.code === 200) {
                listing();
                handleClose()
            }
        } catch (e) {
            console.log("Error:", e.message);
        } finally {
            setButtonLoader(false)
        }
    };
    return (
        <CustomModal
            className={"add_model"}
            show={show}
            handleClose={handleClose}
        >
            <h3>{data?.type} Slot</h3>
            <div className="form_field">
                <label htmlFor="from">From</label>
                <DatePicker
                    id='from'
                    className="form-control input"
                    selected={slot.from}
                    onChange={(date) => handleChange("from", date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    // minTime={getMinTime()}
                    // maxTime={slot.to || setHours(setMinutes(new Date(), 59), 23)}
                />
            </div>
            <div className="form_field">
                <label htmlFor="to">To</label>
                <DatePicker
                    id='to'
                    className="form-control input"
                    selected={slot.to}
                    onChange={(date) => handleChange("to", date)}
                    showTimeSelect
                    showTimeSelectOnly
                    timeIntervals={15}
                    timeCaption="Time"
                    dateFormat="h:mm aa"
                    // minTime={slot.from || getMinTime()}
                    // maxTime={setHours(setMinutes(new Date(), 59), 23)}

                />
            </div>
            <div className="button_wrap">
                <button
                    type="button"
                    className="button light"
                    onClick={handleClose}
                >
                    Cancel
                </button>
                <button
                    type="button"
                    ref={buttonLoader}
                    onClick={updateDeliverySlot}
                    className="button"
                >
                    Submit
                </button>
            </div>
        </CustomModal>
    )
}

export default UpdateSlot